import React, { Component } from 'react';
import Slider from 'react-slick';
import '../../../node_modules/slick-carousel/slick/slick.css';
import '../../../node_modules/slick-carousel/slick/slick-theme.css';
import TestimFamily from '../../images/testimfamily.png';

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
};

const dotsSettings = {
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 8,
    slidesToScroll: 1,
    focusOnSelect: true,
};
class WhatParentsSay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nav1: null,
            nav2: null,
        };
    }

    componentDidMount() {
        this.setState({
            nav1: this.slider1,
            nav2: this.slider2,
        });
    }

    render() {
        return (
            <section className="page-section bg-secondary text-white testimsec">
                <h2 className="yellowtxt">What Parents Say</h2>
                <div
                    id="myCarousel"
                    className="carousel slide"
                    data-ride="carousel"
                >
                    <Slider
                        asNavFor={this.state.nav2}
                        ref={slider => (this.slider1 = slider)}
                        {...dotsSettings}
                        className="carousel-indicators"
                    >
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        
                    </Slider>
                    <Slider
                        {...settings}
                        asNavFor={this.state.nav1}
                        ref={slider => (this.slider2 = slider)}
                        className="carousel-inner"
                    >
                        <div className="item carousel-item active">
                            <p className="testimonial">
                            “7-year-old grandson loved the zip line and swings, but also spent some fun time pretending and relaxing. Nice place! Smaller, safe, quieter.”                            </p>
                            <p className="overview">Michelle M.</p>
                        </div>
                        <div className="item carousel-item">
                            <p className="testimonial">
                            “An awesome place for your little ones to burn off energy. It has a zip line, several types of swings, play kitchen, train set, Legos, trampoline and much more!”                            </p>
                            <p className="overview">Laura M.</p>
                        </div>
                        <div className="item carousel-item">
                            <p className="testimonial">
                            “Nice little play gym. My boys are 11yo and enjoyed it. The new owner is really nice. We had fun!"                            </p>
                            <p className="overview">Danielle T.</p>
                        </div>

                         <div className="item carousel-item">
                            <p className="testimonial">
                            “My son had a great time here. He was about 19 months old when we came. He found plenty to check out and get into."                            </p>
                            <p className="overview">Laurel E.</p>
                        </div> 
                        <div className="item carousel-item">
                            <p className="testimonial">
                            “Super, super cool place for kids. I had the most amazing conversation with the owners. They're so welcoming and cool. Can't wait to go back."                            </p>
                            <p className="overview">Joaniece R.</p>
                        </div> 
                         <div className="item carousel-item">
                            <p className="testimonial">
                            “We Rock the Spectrum Sugar Land has been such a blessing to our kids and our family. The owners cultivate an atmosphere of understanding and support among the parents, and it’s so nice to have a place that supports our kids even when they’re having a hard time."                            </p>
                            <p className="overview">Justin F.</p>
                        </div> 
                         <div className="item carousel-item">
                            <p className="testimonial">
                            “The kids had an absolute blast with We Rock the Spectrum - Sugar Land on day 3 of Week Of The Young Child!  We Rock the Spectrum Kids Gym is the perfect place for children of all abilities to play, grow, and have fun together!"                            </p>
                            <p className="overview">St. Laurence Weekday Children's Program</p>
                        </div> 
                         <div className="item carousel-item">
                            <p className="testimonial">
                            “Our visit to We Rock the Spectrum - Sugar Land was outstanding. The facility is exceptional, and we appreciated having it all to ourselves. Thank you for hosting us."                            </p>
                            <p className="overview">Kis R Kids Academy of North Sugar Land</p>
                        </div> 
                       
                    </Slider>
                    <img
                        className="quoteimg"
                        src={TestimFamily}
                        alt="Testimonials family"
                    />
                </div>
            </section>
        );
    }
}

export default WhatParentsSay;
